module.exports = __webpack_public_path__ + "static/media/16UNODC4.7283ac89.jpg";